<template>
  <v-app id="app">
    
    <drawer v-if="isAuthenticated"></drawer>

    <toolbar></toolbar> 
    
    <v-content>
      <v-container fluid>
        <router-view></router-view>
        <loading></loading>
      </v-container>
    </v-content>

    <peu/>

  </v-app>  
</template>

<script>
import Toolbar from './components/toolbar'
import Drawer from './components/drawer'
import Peu from './components/footer'
import Loading from './components/lib/loading'
import { NOMBRE_ADMINISTRADOR } from './http-common'

import { USER_REQUEST } from './store/actions/user'
import { mapGetters } from 'vuex'

export default {
  components: {
    Toolbar,
    Drawer,
    Peu,
    Loading
  },

  name: 'app',

  data: function () {
    return {
    }
  },

  computed: {
    ...mapGetters(['isAuthenticated'])
  },

  created: function () {
    document.title = NOMBRE_ADMINISTRADOR

    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
    }
  }
}
</script>

<style>
</style>


